/**
 * Calculates span of time between now and supplied date object
 * @param {Date} date initial time
 * @return {number} time span in milliseconds
 */
export function timeSpan(date: Date | number): number {
  if (date instanceof Date) {
    date = date.getTime();
  }
  return new Date().getTime() - date;
}

/**
 * Calculates time left between now and date, given a total time
 * @param {number} totalTime total time in milliseconds
 * @param {Date} date initial time
 * @return {number} time left in milliseconds
 */
export function timeLeft(totalTime: number, date?: Date | number): number {
  date = date || new Date();
  if (date instanceof Date) {
    date = date.getTime();
  }
  return totalTime - timeSpan(date);
}

/**
 * Translates millisecond unit to second
 * @param {number} milliseconds
 * @return {number} seconds
 */
export function millisecondToSecond(milliseconds: number): number {
  return Math.floor(milliseconds / 1000);
}

/**
 * @param {Date} date
 * @return {string}
 */
export function toAPIDate(date: Date): string {
  return date.toISOString().replace(/-/g, '/').split('T')[0];
}

/**
 * @param {Date} date
 * @return {string}
 */
export function toLocalAPIDate(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}/${month}/${day}`;
}

/**
 * @param {Date} date1
 * @param {Date} date2
 * @return {boolean}
 */
export function equalDayMonthYear(date1: Date, date2: Date): boolean {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

/**
 * Gets a date that happened some months ago
 * @param {number} months number must be from 1 to 11, inclusive.
 * @return {Date}
 */
export function monthsAgo(months: number): Date {
  const date = new Date();
  date.setMonth(date.getMonth() - months);
  return date;
}

/**
 * Gets a date that happened some years ago
 * @param {number} years number must be from 1 to 11, inclusive.
 * @return {Date}
 */
export function yearsAgo(years: number): Date {
  const date = new Date();
  date.setFullYear(date.getFullYear() - years);
  return date;
}
